import { Component, Input } from '@angular/core'
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-single-tag-picker',
    templateUrl: './single-tag-picker.component.html',
    styleUrls: ['./single-tag-picker.component.scss'],
    standalone: true,
    imports: [FormsModule],
})
export class SingleTagPickerComponent {
	@Input() placeholder: string = ''
	term: string = ''
}
